import { IntlShape } from "gatsby-plugin-intl"
import { AppState } from "../../data/redux-state"
import { isDecadalVar } from "../../data/json-provider"
import {
  getGeoVariableName,
  getTranslatedGeoVariableName,
} from "../VariableDropdown"
import { applyDerivToYLabel } from "../../utils/derivParam"
import { applyCumulToYLabel } from "../../utils/cumulParam"

export function getYLabelHorizontalDistance(yRange: [number, number]) {
  const max = yRange[1]
  if (max >= 1e8) {
    return -95
  } else if (max >= 1e7) {
    return -85
  } else if (max >= 1e6) {
    return -75
  } else if (max >= 1e5) {
    return -65
  } else if (max >= 1e4) {
    return -55
  } else if (max >= 1e3) {
    return -45
  } else {
    return -40
  }
}

export function getLabelFontSize() {
  if (window.innerWidth >= window.innerHeight) {
    return 14
  } else {
    return 10
  }
}

export function getDataFontSize() {
  if (window.innerWidth >= window.innerHeight) {
    return 9
  } else {
    return 7
  }
}

export function getXLabel(appState: AppState, intl: IntlShape) {
  const urlParams = new URLSearchParams(window.location.search)
  const tTitle = urlParams.get("tTitle")
  if (tTitle) {
    return tTitle
  }
  const variableName = getGeoVariableName(
    appState.indicatorClass,
    appState.geoVariable!
  )
  const isEwmIndicator =
    appState.indicatorClass === "EWM-AT" ||
    appState.indicatorClass === "EWM-EUR"
  const isEwmAmplificationFactor =
    isEwmIndicator && appState.geoVariable?.includes("AmplFactor")
  const hasDecadalEwmSubVariable =
    isEwmIndicator &&
    appState.subVariable.some((subVariable) =>
      subVariable?.toLowerCase()?.includes("decadal")
    )
  if (isEwmAmplificationFactor || hasDecadalEwmSubVariable) {
    return intl.formatMessage({ id: "chart.timeCoreYears" })
  }
  if (isDecadalVar({ indicatorClass: appState.indicatorClass, variableName })) {
    return intl.formatMessage({ id: "chart.timeCenterYears" })
  } else {
    return intl.formatMessage({ id: "chart.timeYears" })
  }
}

export function getYLabel(appState: AppState, intl: IntlShape) {
  const urlParams = new URLSearchParams(window.location.search)
  const yTitle = urlParams.get("yTitle")
  if (yTitle) {
    return yTitle
  }
  const variableName = getTranslatedGeoVariableName(
    appState.indicatorClass,
    appState.geoVariable!,
    intl
  )
  return applyCumulToYLabel(applyDerivToYLabel(variableName + ""))
}